<template>
  <section id="index" class="pb-xl-2 mb-4">
    <h2 class="subtitle h4 bg-c02 text-white rounded-top-1 p-2 px-3">
      <i class="fa fa-calendar-check-o" aria-hidden="true"></i>
      <span>スケジュール一覧</span>
    </h2>
    <div class="bg-white rounded-bottom-1 p-3 p-sm-4 py-2 py-sm-3">
      <!-- schedule Legend -->
      <ScheduleLegend></ScheduleLegend>
      <!-- ./schedule Legend -->
      <div
        class="js-accordion"
        v-for="(daily, key, index) in schedules.daily"
        :key="key"
      >
        <dl class="mb-3">
          <dt
            :id="'daily_' + index"
            class="row g-0 align-items-center p-1 px-3 mb-1"
            :class="{ active: index < 3 }"
            @click="toggleAccordion('daily_' + index)"
          >
            <div class="col">
              <h3 class="d-inline-block">
                {{ daily.dateFormat.year }}
                <span class="fs-x-small hoge">年</span>
                {{ daily.dateFormat.month }}
                <span class="fs-x-small hoge">月</span>
                {{ daily.dateFormat.day }}
                <span class="fs-x-small hoge">
                  日{{ daily.dateFormat.weekday }}
                </span>
              </h3>
              <span
                class="
                  d-inline-block
                  align-middle
                  rounded
                  fs-small
                  lh-1
                  fw-bold
                  bg-white
                  text-c02
                  py-1
                  px-2
                  mb-1
                  ms-1
                "
              >
                {{ daily.count }}
                <span class="fs-x-small">件</span>
              </span>
            </div>
            <!-- /.col -->
            <div class="col-auto me-auto d-none d-sm-flex">
              <a
                class="btn btn-sm btn-c03 lh-sm rounded-pill py-1 px-3"
                :href="daily.dateFormat.createScheduleRoute"
                @click.stop=""
              >
                新規追加
              </a>
            </div>
            <!-- /.col -->
            <div class="col-auto">
              <p class="js-accordion-icon"><span></span><span></span></p>
            </div>
            <!-- /.col -->
          </dt>
          <dd class="mb-2" :style="[index < 3 ? 'display: block;' : '']">
            <div class="table-responsive scrollbar pb-3">
              <table class="table table-bordered h-100">
                <ColGroupByMobile v-if="isMobile"></ColGroupByMobile>
                <ColGroupByPc v-else></ColGroupByPc>
                <TableHead :is-mobile="isMobile"></TableHead>
                <TableBody
                  :schedules="daily.schedules"
                  :isDaily="true"
                  :is-mobile="isMobile"
                ></TableBody>
              </table>
            </div>
            <!-- /.table-responsive -->
          </dd>
        </dl>
      </div>
      <!-- /.accordion -->
    </div>
    <!-- /.bg -->
  </section>
</template>

<script lang="ts">
/* Import Vue */
import { defineComponent } from "vue";
/* Import components */
import ScheduleLegend from "../../../components/legend/legend.vue"; // 凡例
import ColGroupByPc from "./parts/tableColGroupByPc.vue";
import ColGroupByMobile from "./parts/tableColGroupByMobile.vue";
import TableHead from "./parts/tableHead.vue";
import TableBody from "./parts/tableBody.vue";
/* Import Script */
import { toggleAccordion } from "../../../compositions/script/accordion";
/* Import Variables */
import { schedules, anchor } from "../../../compositions/variables"; // DatabaseLists

export default defineComponent({
  props: {
    isMobile: {
      type: Boolean,
      required: false,
      default() {
        return false;
      },
    },
  },
  components: {
    ScheduleLegend,
    ColGroupByPc,
    ColGroupByMobile,
    TableHead,
    TableBody,
  },
  setup(props: { isMobile: Boolean }) {
    const isMobile = props.isMobile;
    return {
      /* valiables */
      schedules,
      anchor,
      isMobile,
      /* script */
      toggleAccordion,
    };
  },
});
</script>
